var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.478 3.22a.75.75 0 0 0-1.28.53v2.871l-3.863 3.863-5.08 1.016a.75.75 0 0 0-.384 1.266l3.182 3.182-3.712 3.712a.75.75 0 1 0 1.06 1.06l3.713-3.712 3.182 3.182a.75.75 0 0 0 1.265-.383l1.017-5.08 3.862-3.863h2.871a.75.75 0 0 0 .53-1.28zm.22 3.712V5.561L18.5 9.364h-1.37a.75.75 0 0 0-.531.22l-4.243 4.242a.75.75 0 0 0-.205.383l-.786 3.93-5.442-5.443 3.929-.786a.75.75 0 0 0 .383-.205l4.243-4.243a.75.75 0 0 0 .22-.53",
    clipRule: "evenodd"
  })));
};
export default SvgPin;